import type { MaybeRefOrGetter } from 'vue'
import { computed, ref } from 'vue'

export const useYouTubeVideo = (target: MaybeRefOrGetter<string | undefined>) => {
  const data = ref<string | undefined>()

  const id = computed<string | undefined>(() => data.value ? extractId(data.value) : undefined)
  const embedUrl = computed<string | undefined>(() => id.value ? `https://www.youtube.com/embed/${id.value}` : undefined)
  const posterUrl = computed<string | undefined>(() => id.value ? `https://i.ytimg.com/vi/${id.value}/maxresdefault.jpg` : undefined)

  const extractId = (url: string): string | undefined => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
    const match = url.match(regExp)
    return (match && match[7].length == 11) ? match[7] : undefined
  }

  if (isRef(target)) {
    watch(
      target,
      () => { data.value = toValue(target) },
      { immediate: true, deep: true },
    )
  }
  else {
    data.value = toValue(target)
  }

  return { id, extractId, embedUrl, posterUrl }
}
